import { mapActions } from 'vuex'
export default {
    data() {
        return {
            tableList: {
                data: [],
                count: 0
            },
            noDataName: 'empty'
        }
    },
    created() {
        this.getSmslist()
    },
    methods: {
        ...mapActions('message', ['smslist']),
        async getSmslist() {
            let res = await this.smslist()
            this.tableList.data = res
        },
        formatter(row) {
            return <span>{row.price}元，{row.count}条</span>
        },
        formatterStatus() {
            return <span>成功</span>
        }
    },
    
    render(e) {
        return (
            <div>
                <el-table data={this.tableList.data}
                    header-cell-style={{ background: '#F5F7FA', color: '#454D53' }} row-key="id">
                        <div slot="empty">
						    <img src={require(`@/assets/image/${this.noDataName}.png`)} style="width: 100%;padding: 115px 0;"/>
					    </div>
                        <el-table-column
                            type="index"
                            width="100" label='序号'></el-table-column>
                        <el-table-column label="短信包" formatter={this.formatter}>
                        </el-table-column>
                        <el-table-column label="状态" width="150" prop="status" formatter={this.formatterStatus}>
                        </el-table-column>
                        <el-table-column label="购买时间" prop="created_time">
                        </el-table-column>
                </el-table>
            </div>
        )
    }
}